export default {
  data() {
    return {
      cardSearch: "",
      cardPage: 1,
      cardPerPage: 10,
    };
  },
  computed: {
    filteredCardRows() {
      const q = (this.cardSearch || "").trim().toLowerCase();
      if (!q) return this.rows;
      const fields = this.letterCardSearchFields || [
        "namFam",
        "codeMeli",
        "zamanInsert",
        "shomareHesab",
        "desc",
        "modat",
        "mablaghSeporde",
        "tarixEmatiazVam",
        "azMah",
        "beMah",
        "modatBazPardakht",
        "daTarikh",
      ];
      return this.rows.filter((row) => {
        const hay = fields
          .map((key) => row[key])
          .concat([this.letterStatusLabel(row)])
          .filter((v) => v != null && v !== "")
          .join(" ")
          .toLowerCase();
        return hay.includes(q);
      });
    },
    pagedCardRows() {
      const start = (this.cardPage - 1) * this.cardPerPage;
      return this.filteredCardRows.slice(start, start + this.cardPerPage);
    },
    cardPageCount() {
      return Math.max(
        1,
        Math.ceil(this.filteredCardRows.length / this.cardPerPage),
      );
    },
  },
  watch: {
    rows() {
      this.cardPage = 1;
    },
    cardSearch() {
      this.cardPage = 1;
    },
  },
  methods: {
    letterStatus(row) {
      if (!row || row.vaziatGrp44 == null) return "pending";
      if (row.vaziatGrp44 == 7190) return "ok";
      if (row.vaziatGrp44 == 7191) return "no";
      return "pending";
    },
    letterStatusLabel(row) {
      const status = this.letterStatus(row);
      if (status === "ok") return "تاییـــد شد";
      if (status === "no") return "رد شــــد";
      return "در حال بررسی";
    },
    letterScoreDateText(row) {
      if (!row) return "";
      return row.tarixEmatiazVam == null
        ? "امتیاز ذخیره گردد"
        : "تا تاریخ " + row.tarixEmatiazVam + " محاسبه گردد";
    },
  },
};
